import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from '../services/utils/breadcrumbs.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent implements OnInit {

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private translateService: TranslateService,
  ) {
  }

  ngOnInit() {
    this.setBreadcrumb('Error');

    this.translateService.get('ERRORS.ERROR').subscribe(title => this.setBreadcrumb(title));
  }

  private setBreadcrumb(title: string) {
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: title, url: '/' },
          ]
      }
    );
  }

}
